module.exports = __webpack_public_path__ + "static/media/user.76b7d4c5.svg";